module.exports = __webpack_public_path__ + "static/media/andora-flag.ec0fab9d.png";